import React, { useState, useRef, useEffect } from "react";
import jsPDF from "jspdf";
import profile2 from "../../Assets/AppComponent/UDS LOGO BLACK LETTER.png";
import html2canvas from "html2canvas";
import { useSelector } from "react-redux";
import Forms from "./forms";

const Allformcreate = () => {
  const [pdfDataUri, setPdfDataUri] = useState("");
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const formsRef = useRef(null);

  const generatePDF = () => {
    const doc = new jsPDF();

    html2canvas(formsRef.current)
      .then((canvas) => {
        console.log("Canvas:", canvas);
        const imageData = canvas.toDataURL("image/png");
        console.log("Image Data URL:", imageData);

        doc.addImage(
          imageData,
          "PNG",
          20,
          10,
          170,
          (canvas.height * 170) / canvas.width
        );

        const pdfData = doc.output("datauristring");
        console.log("Generated PDF Data URI:", pdfData);
        setPdfDataUri(pdfData);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  return (
    <div className={stateDisplay ? "outterContent" : "inner-Content"}>
      {/* <h1>Generate PDF from HTML</h1> */}
      {/* Render the Forms component and pass the ref */}
      <Forms ref={formsRef} />

      {/* Button to trigger PDF generation */}
      <button onClick={generatePDF}>Generate PDF</button>
      <div className="row" style={{ marginLeft: "0px", marginRight: "0px" }}>
        <div className="col-4"></div>
        <div className="col-8">
          {/* Display the PDF in an iframe (optional) */}
          {pdfDataUri && (
            <div className="pdfViewer">
              <iframe
                title="PDF Viewer"
                src={pdfDataUri}
                style={{
                  width: "100%",
                  height: "500px",
                  border: "3px solid red",
                }}
                onError={(e) => console.log("Error loading PDF:", e)}
              />
            </div>
          )}

          
        </div>
      </div>
    </div>
  );
};

export default Allformcreate;
